module.exports = __webpack_public_path__ + "static/img/appstore.1ad0248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/appstore.png
// module id = VF08
// module chunks = 0